export function buildQuery (obj) {
  var result = []
  for (var key in obj) {
    if (Array.isArray(obj)) {
      obj.forEach(item => {
        result.push(key + '=' + item)
      })
    } else {
      result.push(key + '=' + obj[key])
    }
  }
  return result.join('&')
}

export function buildValidURL (str) {
  if (!str || str.startsWith('http')) {
    return str
  }
  return 'http://' + str
}
